import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { MyUtility, MyRange } from '../../comparison';

@Component({
  selector: 'app-scattergram-chart',
  templateUrl: './scattergram-chart.component.html',
  styleUrls: ['./scattergram-chart.component.css']
})
export class ScattergramChartComponent implements AfterViewInit {
  @ViewChild('myCanvas') canvasRef: ElementRef;
  layout: ScattergramGridLayout;

  constructor() {
    this.model = {
      data: new ScattergramData(),
      config: new ScattergramConfig()
    };

    this.layout = new ScattergramGridLayout(this.model.config, this.model.data);
  }

  public model: ScattergramModel;
  public stats: ScattergramStats;
  public statsByDiscrepancyName = {};
  public discrepancyRates = DiscrepancyRate.getAllDiscrepancyRates();

  private _selectedDiscrepancyRate: DiscrepancyRate = null;
  public get selectedDiscrepancyRate(): DiscrepancyRate {
    return this._selectedDiscrepancyRate;
  }
  public set selectedDiscrepancyRate(value: DiscrepancyRate) {
    this._selectedDiscrepancyRate = value;

    this.processStats();
    this.doPaint();
  }

  ngAfterViewInit() {
    this.model.data = new ScattergramData();
    this.model.config = new ScattergramConfig();

    this.processStats();

    console.log("model", this.model);
    console.log("layout", this.layout);

    this.ctx = CanvasRenderingContext2D = this.canvasRef.nativeElement.getContext('2d');
    this.ctx.translate(0.5, 0.5);
    this.doPaint();
  }

  selectedStatGroupName: string = null;
  public setSelectedStatGroup(groupName: string) {
    if (groupName === this.selectedStatGroupName) {
      groupName = null;
    }

    this.selectedStatGroupName = groupName;
    this.doPaint();
  }

  processStats() {
    let processor = new ScattergramProcessor();
    processor.process(this.model.data, this.model.data.selectedRange);
    this.stats = processor.results;

    this.statsByDiscrepancyName = {};
    if (!this.model.data.selectedRange) {
      return;
    }

    for (let i = 0; i < this.discrepancyRates.length; i++) {
      let rate = this.discrepancyRates[i];

      processor = new ScattergramProcessor();
      let range = rate.getAdjustedRange(this.model.data.selectedRange, this.model.data.micValues.length);
      processor.process(this.model.data, range);
      this.statsByDiscrepancyName[rate.name] = processor.results;
    }
  }

  mouseHandler: IMouseHandler;

  handleMouseDown(e) {
    if (e.buttons !== 1) {
      return;
    }

    console.log(e);
    let pt = MyUtility.GetMousePointFromMouseEvent(e);

    for (let tab of this.dragTabs) {
      if (tab.contains(pt)) {
        this.mouseHandler = new DragTabMouseHandler(tab, this);
        this.mouseHandler.handleMouseDown(e);
        return;
      }
    }

    let val = this.layout.getCellIndicesAtLocation(pt.x, pt.y);
    if (val != null) {
      this.mouseHandler = new SelectionMouseHandler(this);
      this.mouseHandler.handleMouseDown(e);
    }
  }

  handleMouseUp(e) {
    if (this.mouseHandler == null) {
      return;
    }

    this.mouseHandler.handleMouseUp(e);
  }

  setSelection(start, end) {
    this.model.data.selectedRange = new ScattergramRange();
    this.model.data.selectedRange.micIndexRange = new MyRange(start.micIndex, end.micIndex);
    this.model.data.selectedRange.diskIndexRange = new MyRange(start.diskIndex, end.diskIndex);
    this.model.data.selectedRange.getInOrder();

    this.model.data.selectedRange.micIndexRange.max += 1;
    this.model.data.selectedRange.diskIndexRange.max += 1;

    this.processStats();
    this.doPaint();
  }

  handleMouseMove(e) {
    if (!this.mouseHandler) {
      return;
    }

    this.mouseHandler.handleMouseMove(e);
  }

  handleMouseLeave(e) {
    if (!this.mouseHandler) {
      return;
    }

    this.mouseHandler.handleMouseLeave(e);
  }

  private ctx: any;

  doPaint() {
    this.ctx.fillStyle = this.model.config.backColor;
    this.ctx.lineWidth = 1;

    this.ctx.fillRect(0, 0, this.layout.width, this.layout.height);

    this.drawHighlightedZones();

    this.ctx.beginPath();
    let gridCorner = this.layout.getCellLocation(0, 0);
    let gridTop = this.layout.getCellLocation(0, this.model.data.micValues.length);
    let gridRight = this.layout.getCellLocation(this.model.data.zoneSizes.length, 0);
    this.ctx.moveTo(gridTop.x, gridTop.y);
    this.ctx.lineTo(gridCorner.x, gridCorner.y);
    this.ctx.lineTo(gridRight.x, gridRight.y);

    this.ctx.strokeStyle = this.model.config.lineColor;
    this.ctx.stroke();

    this.drawDividers();

    this.drawCellCountsAndLabels();

    if (this.model.data.selectedRange) {
      this.drawSelectedRange();
    }
  }

  highlightedZoneName = "Very Major";

  drawHighlightedZones() {
    if (!this.selectedStatGroupName || !this.stats) {
      console.log("No stat group selected");
      return;
    }

    let selectedStatGroup = this.stats[this.selectedStatGroupName];
    if (!selectedStatGroup) {
      return;
    }


    console.log("selectedStatGroup", selectedStatGroup);

    let ctx = this.ctx;
    this.ctx.fillStyle = this.model.config.zoneFillStyle;
    let rects = selectedStatGroup.rects;
    if (!rects || rects.length < 1) {
      return;
    }

    for (let i = 0; i < rects.length; i++) {
      ctx.beginPath();
      let rect = rects[i];
      console.log("rect", rect);

      let upperLeft = this.layout.getCellLocation(rect.left, rect.top);
      let upperRight = this.layout.getCellLocation(rect.right, rect.top);
      let lowerRight = this.layout.getCellLocation(rect.right, rect.bottom);
      let lowerLeft = this.layout.getCellLocation(rect.left, rect.bottom);

      ctx.moveTo(upperLeft.x, upperLeft.y);
      ctx.lineTo(upperRight.x, upperRight.y);
      ctx.lineTo(lowerRight.x, lowerRight.y);
      ctx.lineTo(lowerLeft.x, lowerLeft.y);

      ctx.fill();
    }
  }

  dragTabs = [];

  drawLine(a, b, strokeStyle, lineWidth = 1, lineDash = []) {
    let ctx = this.ctx;

    ctx.strokeStyle = strokeStyle;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(lineDash);
    ctx.beginPath();
    ctx.moveTo(a.x, a.y);
    ctx.lineTo(b.x, b.y);
    ctx.stroke();
  }

  drawHorizontalLine(micIndex, strokeStyle, lineWidth = 1, lineDash = []) {
    let y = this.layout.getCellLocation(0, micIndex).y;
    let a = { x: this.layout.gridLeft, y: y };
    let b = { x: this.layout.gridRight, y: y };
    this.drawLine(a, b, strokeStyle, lineWidth, lineDash);
  }

  drawVerticalLine(diskIndex, strokeStyle, lineWidth = 1, lineDash = []) {
    let x = this.layout.getCellLocation(diskIndex, 0).x;
    let a = { x: x, y: this.layout.gridTop };
    let b = { x: x, y: this.layout.gridBottom };
    this.drawLine(a, b, strokeStyle, lineWidth, lineDash);
  }

  drawSelectedRange() {
    let range = this.model.data.selectedRange;
    if (!range) {
      return;
    }
    range.getInOrder();

    let altRange = null;
    if (this.selectedDiscrepancyRate) {
      altRange = this.selectedDiscrepancyRate.getAdjustedRange(range, this.model.data.micValues.length);
    }

    let layout = this.layout;

    this.dragTabs = [];

    // Red lines
    let xIndex = range.diskIndexRange.min;
    this.drawVerticalLine(xIndex, this.model.config.selectionMinStyle, this.model.config.selectionLineWidth);
    let x = layout.getCellLocation(xIndex, 0).x;

    let yIndex = range.micIndexRange.max;
    let y = layout.getCellLocation(0, yIndex).y;
    this.drawHorizontalLine(yIndex, this.model.config.selectionMinStyle, this.model.config.selectionLineWidth);

    if (altRange) {
      console.log("range", range);
      console.log("ALTRANGE", altRange);
      if (range.micIndexRange.min !== altRange.micIndexRange.min) {
        yIndex = altRange.micIndexRange.min;
        this.drawHorizontalLine(yIndex, this.model.config.selectionMaxStyle, this.model.config.selectionLineWidth, [6, 10]);
      }
      if (range.micIndexRange.max !== altRange.micIndexRange.max) {
        yIndex = altRange.micIndexRange.max;
        this.drawHorizontalLine(yIndex, this.model.config.selectionMinStyle, this.model.config.selectionLineWidth, [6, 10]);
      }
    }

    this.dragTabs.push(new DragTab({ x: x, y: layout.gridTop }, this.model.config.selectionMinStyle, p => this.handleDiskDragTab(p, true), true));
    this.dragTabs.push(new DragTab({ x: layout.gridRight, y: y }, this.model.config.selectionMinStyle, p => this.handleMicDragTab(p, true), false));


    // Green lines
    xIndex = range.diskIndexRange.max;
    x = layout.getCellLocation(xIndex, 0).x;
    this.drawVerticalLine(xIndex, this.model.config.selectionMaxStyle, this.model.config.selectionLineWidth);

    yIndex = range.micIndexRange.min;
    y = layout.getCellLocation(0, yIndex).y;
    this.drawHorizontalLine(yIndex, this.model.config.selectionMaxStyle, this.model.config.selectionLineWidth);

    this.dragTabs.push(new DragTab({ x: x, y: layout.gridTop }, this.model.config.selectionMaxStyle, p => this.handleDiskDragTab(p, false), true));
    this.dragTabs.push(new DragTab({ x: layout.gridRight, y: y }, this.model.config.selectionMaxStyle, p => this.handleMicDragTab(p, false), false));

    for (let i = 0; i < this.dragTabs.length; i++) {
      let tab = this.dragTabs[i];
      tab.draw(this.ctx);
    }
  }

  handleMicDragTab(mousePoint, isMin) {
    let cellCoordinates = this.layout.getCellIndicesAtLocation(this.layout.gridLeft + 1, mousePoint.y);
    if (cellCoordinates == null) {
      return;
    }

    if (!isMin) {
      this.model.data.selectedRange.micIndexRange.min = cellCoordinates.micIndex;
    }
    else {
      this.model.data.selectedRange.micIndexRange.max = cellCoordinates.micIndex;
    }

    this.processStats();
    this.doPaint();
  }

  handleDiskDragTab(mousePoint, isMin) {
    let cellCoordinates = this.layout.getCellIndicesAtLocation(mousePoint.x, this.layout.gridTop + 1);
    if (cellCoordinates == null) {
      return;
    }

    if (isMin) {
      this.model.data.selectedRange.diskIndexRange.min = cellCoordinates.diskIndex;
    }
    else {
      this.model.data.selectedRange.diskIndexRange.max = cellCoordinates.diskIndex;
    }

    this.processStats();
    this.doPaint();
  }

  drawCellCountsAndLabels() {
    let ctx = this.ctx;

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    let xOffset = .5;
    let yOffset = -0.5;
    this.model.data.values.forEach(v => {
      let xIndex = this.model.data.getZoneIndex(v.zoneSize);
      let yIndex = this.model.data.getMicIndex(v.mic);

      let textPoint = this.layout.getCellLocation(xIndex + xOffset, yIndex + .5);

      ctx.strokeStyle = this.model.config.textColor;
      ctx.fillStyle = this.model.config.textColor;
      ctx.fillText(String(v.value), textPoint.x, textPoint.y);
    });

    for (let i = 0; i < this.model.data.zoneSizes.length; i++) {
      let textPoint = this.layout.getCellLocation(i + .5, yOffset);

      ctx.strokeStyle = this.model.config.textColor;
      ctx.fillStyle = this.model.config.textColor;
      ctx.fillText(String(this.model.data.zoneSizes[i]), textPoint.x, textPoint.y);
    }

    ctx.textAlign = "right";
    for (let i = 0; i < this.model.data.micValues.length; i++) {
      let textPoint = this.layout.getCellLocation(0, i + .5);
      textPoint.x -= 3;

      ctx.strokeStyle = this.model.config.textColor;
      ctx.fillStyle = this.model.config.textColor;
      ctx.fillText(String(this.model.data.micValues[i]), textPoint.x, textPoint.y);
    }
  }

  drawDividers() {
    let ctx = this.ctx;

    ctx.beginPath();
    ctx.strokeStyle = this.model.config.dividerColor;
    for (let x = 0; x < this.model.data.zoneSizes.length; x++) {
      let a = this.layout.getCellLocation(x + 1, 0);
      let b = this.layout.getCellLocation(x + 1, this.model.data.micValues.length);
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
    }
    for (let y = 0; y < this.model.data.micValues.length; y++) {
      let a = this.layout.getCellLocation(0, y + 1);
      let b = this.layout.getCellLocation(this.model.data.zoneSizes.length, y + 1);
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
    }
    ctx.stroke();
  }
}

export class ScattergramModel {
  public config: ScattergramConfig;
  public data: ScattergramData;
}

export class ScattergramGridLayout {

  public config;
  public data;
  public width;
  public height;
  public gridLeft;
  public gridRight;
  public gridTop;
  public gridBottom;

  constructor(config: ScattergramConfig, data: ScattergramData) {
    this.config = config;
    this.data = data;

    this.width = data.zoneSizes.length * config.cellSize + config.leftMargin + config.rightMargin;
    this.height = data.micValues.length * config.cellSize + config.bottomMargin + config.topMargin;

    this.gridLeft = config.leftMargin;
    this.gridRight = this.width - config.rightMargin;
    this.gridTop = this.config.topMargin;
    this.gridBottom = this.height - config.bottomMargin;
  }

  getCellLocation(xIndex, yIndex) {
    let retval = new Point(
      this.config.leftMargin + xIndex * this.config.cellSize,
      this.gridBottom - yIndex * this.config.cellSize
    );
    return retval;
  }

  getCellAtLocation(x: number, y: number): any {
    let cellX = Math.floor((x - this.gridLeft) / this.config.cellSize);
    let cellY = Math.floor((this.gridBottom - y) / this.config.cellSize);

    console.log({ cellX: cellX, cellY: cellY });

    if (cellX < 0 || cellX >= this.data.zoneSizes.length || cellY < 0 || cellY >= this.data.micValues.length) {
      return null;
    }

    return { disk: this.data.zoneSizes[cellX], mic: this.data.micValues[cellY] };
  }

  getCellIndicesAtLocation(x: number, y: number): any {
    let cellX = Math.floor((x - this.gridLeft) / this.config.cellSize);
    let cellY = Math.floor((this.gridBottom - y) / this.config.cellSize);

    if (cellX < 0 || cellX >= this.data.zoneSizes.length || cellY < 0 || cellY >= this.data.micValues.length) {
      return null;
    }

    return { diskIndex: cellX, micIndex: cellY };
  }
}

export class Point {
  x: number;
  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }
}

export class ScattergramConfig {
  cellSize = 18;
  leftMargin = 50;
  bottomMargin = 30;
  lineColor = 'grey';
  dividerColor = '#DDD';
  tickColor = 'grey';
  tickLength = 6;
  backColor = 'white';
  textColor = 'black';
  rightMargin = 18;
  topMargin = 18;
  selectionMinStyle = "red";
  selectionMaxStyle = "green";
  selectionLineWidth = 2;
  zoneFillStyle = "#F9FFEE";
}

export class ScattergramData {

  public zoneSizes: string[];
  public micValues: string[];
  public values: ScattergramValue[];
  public selectedRange: ScattergramRange;

  constructor() {
    this.zoneSizes = MyUtility.range(6, 40).map(x => x.toString());
    this.zoneSizes.push('>40');

    this.micValues = ['<=.002', '.004', '.008', '.015', '.03', '.06', '.12', '.25', '.5', '1', '2', '4', '8', '16', '32', '64', '128', '256', '512', '>512'];

    this.values = [
      // new ScattergramValue(55, 6, .002),
      new ScattergramValue(1, '20', '.12'),
      new ScattergramValue(12, '23', '.12'),
      new ScattergramValue(13, '24', '.12'),
      new ScattergramValue(13, '25', '.12'),
      new ScattergramValue(2, '25', '.5'),
      new ScattergramValue(4, '26', '.12'),
      new ScattergramValue(14, '27', '.12'),
      new ScattergramValue(3, '27', '.5'),
      new ScattergramValue(24, '28', '.12'),
      new ScattergramValue(29, '29', '.12'),
      new ScattergramValue(12, '30', '.12'),
      new ScattergramValue(3, '31', '.12'),
      new ScattergramValue(1, '32', '.12')
    ];
  }

  getZoneIndex(zoneValue) {
    return this.zoneSizes.indexOf(zoneValue);
  }

  getMicIndex(micValue) {
    return this.micValues.indexOf(micValue);
  }
}

export class ScattergramRange {
  getInOrder(): any {
    this.diskIndexRange.getInOrder();
    this.micIndexRange.getInOrder();
  }

  public diskIndexRange: MyRange;
  public micIndexRange: MyRange;

  public get mode(): string {
    if (this.micIndexRange.span === 0) {
      return "narrow";
    }
    return "regular";
  }
}

export class ScattergramValue {
  value: number;
  zoneSize: string;
  mic: string;

  constructor(value: number, zoneSize: string, mic: string) {
    this.value = value;
    this.zoneSize = zoneSize;
    this.mic = mic;
  }
}

export class ScattergramProcessor {
  results: ScattergramStats;

  process(data: ScattergramData, range: ScattergramRange) {
    this.results = new ScattergramStats();

    if (!range) {
      return;
    }

    let bins = {
      '1': { '-1': [], '0': [], '1': [] },
      '0': { '-1': [], '0': [], '1': [] },
      '-1': { '-1': [], '0': [], '1': [] }
    };

    for (let i = 0; i < data.values.length; i++) {
      let point = data.values[i];

      let diskIndex = data.zoneSizes.indexOf(point.zoneSize);
      let micIndex = data.micValues.indexOf(point.mic);

      let zone = range.diskIndexRange.compareValue(diskIndex);
      let mic = range.micIndexRange.compareValue(micIndex);

      bins[zone][mic].push(point);

      this.results.totalCount += point.value;
    }

    console.log(`${bins[-1][1].length},${bins[0][1].length},${bins[1][1].length}`);
    console.log(`${bins[-1][0].length},${bins[0][0].length},${bins[1][0].length}`);
    console.log(`${bins[-1][-1].length},${bins[0][-1].length},${bins[1][-1].length}`);

    let minor = bins[-1][0].concat(bins[0][1], bins[0][-1], bins[1][0]);
    this.results.minorPoints = new ScattergramStatGroup(minor, this.results.totalCount, this.getMinorRects(data));
    this.results.majorPoints = new ScattergramStatGroup(bins[-1][-1], this.results.totalCount, this.getMajorRects(data));
    this.results.veryMajorPoints = new ScattergramStatGroup(bins[1][1], this.results.totalCount, this.getVeryMajorRects(data));

    // this.calculateRectangles(data);

    console.log("stats results", this.results);
  }

  private getVeryMajorRects(data: ScattergramData) {
    return [new Rect(
      data.selectedRange.diskIndexRange.max,
      data.micValues.length,
      data.zoneSizes.length,
      data.selectedRange.micIndexRange.max
    )];
  }
  private getMajorRects(data: ScattergramData) {
    return [new Rect(
      0,
      data.selectedRange.micIndexRange.min,
      data.selectedRange.diskIndexRange.min,
      0
    )];
  }
  private getMinorRects(data: ScattergramData) {
    let micMinIndex = data.selectedRange.micIndexRange.min;
    let micMaxIndex = data.selectedRange.micIndexRange.max;
    let micTop = data.micValues.length;
    let zoneMinIndex = data.selectedRange.diskIndexRange.min;
    let zoneMaxIndex = data.selectedRange.diskIndexRange.max;
    let zoneRight = data.zoneSizes.length;

    return [
      new Rect(
        0,
        micMaxIndex,
        zoneMinIndex,
        micMinIndex
      ),
      new Rect(
        zoneMinIndex,
        micTop,
        zoneMaxIndex,
        micMaxIndex
      ),
      new Rect(
        zoneMaxIndex,
        micMaxIndex,
        zoneRight,
        micMinIndex
      ),
      new Rect(
        zoneMinIndex,
        micMinIndex,
        zoneMaxIndex,
        0
      ),
    ];
  }
}

class Rect {
  constructor(public left: number, public top: number, public right: number, public bottom: number) { }
}

export class ScattergramStats {
  veryMajorPoints: ScattergramStatGroup;
  majorPoints: ScattergramStatGroup;
  minorPoints: ScattergramStatGroup;
  totalCount: number;

  constructor() {
    this.totalCount = 0;
  }
}

export class ScattergramStatGroup {
  points: ScattergramValue[];
  totalCount: number;
  grandTotalCount: number;

  constructor(points: ScattergramValue[], grandTotal: number, public rects: Rect[]) {
    this.grandTotalCount = grandTotal;
    let total = 0;
    for (let i = 0; i < points.length; i++) {
      total += points[i].value;
    }
    this.totalCount = total;
  }

  get percentageOfGrandTotal() {
    return this.totalCount / this.grandTotalCount;
  }
}

interface IMouseHandler {
  handleMouseMove(event);
  handleMouseDown(event);
  handleMouseUp(event);
  handleMouseLeave(event);
}

class SelectionMouseHandler implements IMouseHandler {
  private dragStart;
  get layout() {
    return this.component.layout;
  }

  constructor(private component: ScattergramChartComponent) {
  }

  handleMouseMove(event: any) {
    if (this.dragStart === null) {
      return;
    }

    let pt = MyUtility.GetMousePointFromMouseEvent(event);
    let val = this.layout.getCellIndicesAtLocation(pt.x, pt.y);
    if (val === null) {
      return;
    }

    this.component.setSelection(this.dragStart, val);
  }
  handleMouseDown(event: any) {
    let pt = MyUtility.GetMousePointFromMouseEvent(event);
    let val = this.layout.getCellIndicesAtLocation(pt.x, pt.y);
    if (val == null) {
      return;
    }

    this.dragStart = val;
  }
  handleMouseUp(event: any) {
    let pt = MyUtility.GetMousePointFromMouseEvent(event);
    let val = this.layout.getCellIndicesAtLocation(pt.x, pt.y);
    if (val !== null) {
      this.component.setSelection(this.dragStart, val);
    }
    this.dragStart = null;
    this.component.mouseHandler = null;
  }
  handleMouseLeave(event: any) {
    this.handleMouseUp(event);
  }
}

class DragTabMouseHandler implements IMouseHandler {
  constructor(private tab: DragTab, private component: ScattergramChartComponent) {
  }

  handleMouseMove(event: any) {
    let mousePoint = MyUtility.GetMousePointFromMouseEvent(event);
    let offset = this.component.layout.config.cellSize / 2;
    mousePoint.x += offset;
    mousePoint.y -= offset;
    this.tab.setter(mousePoint);
  }
  handleMouseDown(event: any) {
    this.handleMouseMove(event);
  }
  handleMouseUp(event: any) {
    this.handleMouseMove(event);
    this.component.mouseHandler = null;
  }
  handleMouseLeave(event: any) {
    this.handleMouseUp(event);
  }
}

class DragTab {
  private points = [];
  private rect;

  constructor(private origin, private fillStyle: string, public setter, private isVertical: boolean) {
    this.updatePoints();
  }

  updatePoints() {
    if (this.isVertical) {
      this.points = [];
      this.points.push(this.origin);
      this.points.push({ x: this.origin.x + 5, y: this.origin.y - 5 });
      this.points.push({ x: this.origin.x + 5, y: this.origin.y - 15 });
      this.points.push({ x: this.origin.x - 5, y: this.origin.y - 15 });
      this.points.push({ x: this.origin.x - 5, y: this.origin.y - 5 });

      this.rect = {
        left: this.origin.x - 5,
        top: this.origin.y - 15,
        right: this.origin.x + 5,
        bottom: this.origin.y,
        contains: function (p) {
          return p.x >= this.left && p.x <= this.right && p.y >= this.top && p.y <= this.bottom;
        }
      };
    } else {
      this.points = [];
      this.points.push(this.origin);
      this.points.push({ x: this.origin.x + 5, y: this.origin.y - 5 });
      this.points.push({ x: this.origin.x + 15, y: this.origin.y - 5 });
      this.points.push({ x: this.origin.x + 15, y: this.origin.y + 5 });
      this.points.push({ x: this.origin.x + 5, y: this.origin.y + 5 });

      this.rect = {
        left: this.origin.x,
        top: this.origin.y - 5,
        right: this.origin.x + 15,
        bottom: this.origin.y + 5,
        contains: function (p) {
          return p.x >= this.left && p.x <= this.right && p.y >= this.top && p.y <= this.bottom;
        }
      };

    }
  }

  contains(point) {
    return this.rect.contains(point);
  }

  draw(ctx) {
    ctx.fillStyle = this.fillStyle;
    ctx.beginPath();

    ctx.moveTo(this.points[0].x, this.points[0].y);
    for (let i = 1; i < this.points.length; i++) {
      ctx.lineTo(this.points[i].x, this.points[i].y);
    }

    ctx.fill();
  }
}

class DiscrepancyRate {
  public name: string;
  constructor(displayFormula: string, micRangeFunc: any, narrowDisplayFormula: string, narrowMicRangeFunc: any, public limits: DiscrepancyRateLimit) {
    if (narrowDisplayFormula === null) {
      narrowDisplayFormula = displayFormula;
    }
    if (!narrowMicRangeFunc) {
      narrowMicRangeFunc = micRangeFunc;
    }

    this.name = displayFormula;
    this.versions["regular"] = { displayFormula: displayFormula, micRangeFunc: micRangeFunc };
    this.versions["narrow"] = { displayFormula: narrowDisplayFormula, micRangeFunc: narrowMicRangeFunc };
  }

  public versions = {};

  getAdjustedRange(regularRange: ScattergramRange, maxValidMicIndex: number): ScattergramRange {
    let retval = new ScattergramRange();
    console.log("mode", regularRange.mode);
    console.log("version", this.versions[regularRange.mode]);
    retval.micIndexRange = this.versions[regularRange.mode].micRangeFunc(regularRange.micIndexRange, maxValidMicIndex);
    retval.micIndexRange.getInOrder();
    retval.micIndexRange.clampTo(0, maxValidMicIndex);

    retval.diskIndexRange = new MyRange(regularRange.diskIndexRange.min, regularRange.diskIndexRange.max);
    return retval;
  }

  static getAllDiscrepancyRates() {
    let retval = [];
    retval.push(new DiscrepancyRate(">/= I(high)+2", (x, limit) => new MyRange(x.max + 2, limit), ">/= R+1", (x, limit) => new MyRange(x.max + 1, limit), new DiscrepancyRateLimit(.02, null, .05)));
    retval.push(new DiscrepancyRate("I(high)+1 to I(low)-1)", (x, limit) => new MyRange(x.min - 1, x.max + 1), "R + S", (x, limit) => new MyRange(x.min, x.max), new DiscrepancyRateLimit(.1, .1, .4)));
    retval.push(new DiscrepancyRate("</= I(low)-2", (x, limit) => new MyRange(0, x.min - 2), "</= S-1", (x, limit) => new MyRange(0, x.min - 1), new DiscrepancyRateLimit(null, .02, .05)));
    retval.push(new DiscrepancyRate("All Isolates", (x, limit) => new MyRange(x.min, x.max), null, null, new DiscrepancyRateLimit(null, null, null)));
    return retval;
  }
}

class DiscrepancyRateLimit {
  constructor(public veryMajor: number, public major: number, minor: number) { }
}

enum ErrorType {
  Minor = "Minor",
  Major = "Major",
  VeryMajor = "Very Major"
}
